<template>
  <div class="floorCardList">
    <ul
      :style="styleCardList"
      :class="{'noTransition' : Math.abs(this.touch.deltaX) > this.touch.threshSwipe
          && !this.touch.scrollLock}">
      <li
        v-for="(floor, index) in floors"
        :key="index"
      >
        <FloorCard
          :class="{'noClick':touch.swipeLock}"
          :floor="floor"
          :index="index"
          :visible="index > currentFloorIndex-2 && index < currentFloorIndex+2"
          ref="floorCard"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FloorCard from './FloorCard.vue';

export default {
  components: {
    FloorCard,
  },
  props: {
    floors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      touch: {
        rafPending: false, // Request Animation Frame Pending
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0,
        deltaX: 0,
        deltaY: 0,
        scrollLock: false,
        swipeLock: false,
        threshSwipe: 5,
      },
    };
  },
  computed: {
    ...mapGetters(['currentFloorIndex', 'currentRoomIndex']),
    styleCardList() {
      return {
        width: `${this.floors.length * 100}%`,
        transform: Math.abs(this.touch.deltaX)
          > (Math.abs(this.touch.deltaY) + this.touch.threshSwipe) && !this.touch.scrollLock
          ? `translateX(${(-this.currentFloorIndex + (this.touch.deltaX) / document.body.clientWidth) * (100 / this.floors.length)}%)`
          : `translateX(${-this.currentFloorIndex * (100 / this.floors.length)}%)`,
      };
    },
    hasTouch() {
      return this.$helper.hasTouch();
    },
  },
  methods: {
    ...mapActions(['setFloorIndex', 'resetNavigation']),
    nextIndex(direction) {
      const nextFloor = this.currentFloorIndex + direction;
      if (nextFloor < 0 || nextFloor > this.floors.length - 1) { return; }
      this.setFloorIndex(nextFloor);
      this.$router.push({ name: 'Floor', params: { floorId: nextFloor } });

      // close all open rooms
      /* this.$nextTick().then(() => {
        this.resetNavigation();
      }); */
    },
    /* eslint max-len: 0 */ // disable max line length
    // TOUCH interaction
    touchOnAnimFrame() {
      if (!this.touch.rafPending) {
        return;
      }

      this.touch.deltaX = this.touch.endX - this.touch.startX;
      this.touch.deltaY = this.touch.endY - this.touch.startY;

      if (Math.abs(this.touch.deltaX) > Math.abs(this.touch.deltaY)
        + this.touch.threshSwipe && !this.touch.swipeLock) {
        this.touch.swipeLock = true;
      } else if (Math.abs(this.touch.deltaY) > Math.abs(this.touch.deltaX)
        + this.touch.threshSwipe && !this.touch.swipeLock) {
        this.touch.scrollLock = true;
      }

      this.touch.rafPending = false;
    },
    touchstart(e) {
      if (this.currentRoomIndex !== null) {
        return;
      }

      if (this.hasTouch) {
        // this.$el.addEventListener('touchmove', (event) => this.touchmove(event));
        // this.$el.addEventListener('touchend', () => this.touchend());
        this.$el.ontouchmove = (event) => { this.touchmove(event); };
        document.ontouchend = () => { this.touchend(); };

        this.touch.startX = e.touches[0].clientX;
        this.touch.startY = e.touches[0].clientY;
      } else {
        // this.$el.addEventListener('mousemove', (event) => this.touchmove(event));
        // this.$el.addEventListener('mouseup', () => this.touchend());
        this.$el.onmousemove = (event) => { this.touchmove(event); };
        document.onmouseup = () => { this.touchend(); };

        this.touch.startX = e.clientX;
        this.touch.startY = e.clientY;
      }

      this.touch.endX = this.touch.startX;
      this.touch.endY = this.touch.startY;
    },
    touchmove(e) {
      if (this.touch.startX < 1 || this.currentRoomIndex !== null) {
        return;
      }
      if (this.hasTouch) {
        this.touch.endX = e.touches[0].clientX;
        this.touch.endY = e.touches[0].clientY;
      } else {
        this.touch.endX = e.clientX;
        this.touch.endY = e.clientY;
      }
      if (this.touch.rafPending) {
        return;
      }
      this.touch.rafPending = true;
      window.requestAnimationFrame(() => { this.touchOnAnimFrame(); });
    },
    touchend() {
      if (this.currentRoomIndex !== null) { return; }
      if (this.touch.swipeLock) {
        if (this.touch.endX < this.touch.startX - this.touch.threshSwipe) {
          this.nextIndex(1); // USE EVENT onSwipeLeft
        } else if (this.touch.endX > this.touch.startX + this.touch.threshSwipe) {
          this.nextIndex(-1);
        }
      }
      this.touch.startX = 0;
      this.touch.startY = 0;
      this.touch.endX = 0;
      this.touch.endY = 0;
      this.touch.deltaX = 0;
      this.touch.deltaY = 0;
      this.touch.scrollLock = false;
      this.touch.swipeLock = false;

      if (this.hasTouch) {
        // this.$el.removeEventListener('touchmove', (event) => this.touchmove(event));
        // this.$el.removeEventListener('touchend', () => this.touchend());
        this.$el.ontouchmove = null;
        document.ontouchend = null;
      } else {
        // this.$el.removeEventListener('mousemove', (event) => this.touchmove(event));
        // this.$el.removeEventListener('mouseup', () => this.touchend());
        this.$el.onmousemove = null;
        document.onmouseup = null;
      }
    },
  },
  mounted() {
    if (this.hasTouch) {
      // this.$el.addEventListener('touchstart', (event) => this.touchstart(event));
      this.$el.ontouchstart = (event) => { this.touchstart(event); };
    } else {
      // this.$el.addEventListener('mousedown', (event) => this.touchstart(event));
      this.$el.onmousedown = (event) => { this.touchstart(event); };
    }
  },
  beforDestroy() {
    if (this.hasTouch) {
      // this.$el.removeEventListener('touchstart', (event) => this.touchstart(event));
      this.$el.ontouchstart = null;
    } else {
      // this.$el.removeEventListener('mousedown', (event) => this.touchstart(event));
      this.$el.onmousedown = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.floorCardList {
  margin: 0;
  padding: 0;
  overflow: hidden;
  ul {
    display: flex;
    height: 77vh;
    height: calc(var(--vh, 1vh) * 77);
    list-style: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  ul:not(.noTransition){ /* prevent Transition while draging */
    transform: translateX(0);
    transition: transform .2s ease;
  }
  li {
    width: 100vw;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
}
@media only screen and (orientation : landscape) {
  .floorCardList {
    ul {
      height:77vh;
      height: calc(var(--vh, 1vh) * 77);
    }
  }
}
</style>
